var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { row: "", wrap: "" } },
    _vm._l(_vm.dataSource.SurveyInformations, function (surveyInformation) {
      return _c(
        "v-layout",
        { key: surveyInformation.id },
        [
          _c(
            "v-flex",
            {
              staticClass: "pr-1",
              attrs: { xs4: "", "data-ui-component": "Survey Type" },
            },
            [
              _c(
                "SummaryTile",
                { attrs: { title: "Survey Type" } },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(surveyInformation.SurveyType) +
                      "\n          "
                  ),
                  _c("v-icon", [_vm._v("content_paste")]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            {
              staticClass: "pr-1",
              attrs: { xs4: "", "data-ui-component": "Survey Count" },
            },
            [
              _c(
                "SummaryTile",
                { attrs: { title: "Surveys" } },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(surveyInformation.NumberOfSurveys) +
                      "\n          "
                  ),
                  _c("v-icon", [_vm._v("content_paste")]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            {
              staticClass: "px-1",
              attrs: { xs4: "", "data-ui-component": "First Survey Date" },
            },
            [
              _c(
                "SummaryTile",
                { attrs: { title: "From" } },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.formatDate(surveyInformation.FirstSurveyDate)
                      ) +
                      "\n          "
                  ),
                  _c("v-icon", [_vm._v("event")]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            {
              staticClass: "pl-1",
              attrs: { xs4: "", "data-ui-component": "Last Survey Date" },
            },
            [
              _c(
                "SummaryTile",
                { attrs: { title: "To" } },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.formatDate(surveyInformation.LastSurveyDate)) +
                      "\n          "
                  ),
                  _c("v-icon", [_vm._v("event")]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            {
              staticClass: "px-1",
              attrs: { xs4: "", "data-ui-component": "Specimens Count" },
            },
            [
              _c(
                "SummaryTile",
                { attrs: { title: "Specimens" } },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(surveyInformation.NumberOfSpecimences) +
                      "\n          "
                  ),
                  _c("v-icon", [_vm._v("content_paste")]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }